import React from "react";
import styled from "styled-components";
import Sidebar from "./Sidebar";

const Page = styled.main`
  min-height: 70vh;
  padding: 30px 18px;
  background: #f7fafc;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 16px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const Content = styled.section`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 12px 34px rgba(0,0,0,0.06);
  padding: 16px;
`;

export default function AdminLayout({ children }) {
  return (
    <Page>
      <Container>
        <Sidebar />
        <Content>{children}</Content>
      </Container>
    </Page>
  );
}
